import { CardContent, Grid } from '@material-ui/core';
import { Card, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getOutForSignatureStatuses } from '../../../../redux/deals/action';
import { groupJsonByVal } from '../../../../utils/groupJsonByVal';
import styles from './PendingStatus.module.scss';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { humanizer } from '../../../../utils/snakeCaseToHumanize';
import { typography } from '@mui/system';
import _ from 'lodash';

const PendingStatus = ({
	purchaserList,
	getOutForSignatureStatuses,
	pendingSignatures,
	checked,
	setChecked,
}) => {
	const [documentSignatures, setDocumentSignatures] = useState();
	const [active, setActive] = useState({});

	useEffect(() => {
		getOutForSignatureStatuses(purchaserList);
	}, [purchaserList]);

	useEffect(() => {
		var groupedStatuses = groupJsonByVal(pendingSignatures, 'documentName');

		var groupedStatusesKeys = Object.keys(groupedStatuses);

		var documentSignaturesArr = [];
		var documentNameObj = {};

		groupedStatusesKeys.forEach((key) => {
			var documentStatus = groupedStatuses[key];
			documentNameObj[key] = false;

			var groupedDocuments = groupJsonByVal(documentStatus, 'status');

			console.log('groupedDocuments', groupedDocuments);
			var finalJson = {
				documentName: key,
				documentStatuses: groupedDocuments,
			};
			documentSignaturesArr.push(finalJson);
		});

		setDocumentSignatures(documentSignaturesArr);

		setActive(documentNameObj);

		console.log('groupedStatuses', groupedStatuses);
	}, [pendingSignatures]);

	useEffect(() => {
		console.log('documentSignatures', documentSignatures);
	}, [documentSignatures]);

	const handleClickTab = (e) => {
		var name = e.currentTarget.dataset.tab;

		setActive({ ...active, [name]: !active[name] });
	};

	const handleClickCheck = (e) => {
		console.log('eee', e.target.name);

		setChecked({
			...checked,
			[e.target.name]:
				e.target.checked === true && e.target.value.split(','),
		});
	};

	useEffect(() => {
		console.log('checkedcheckedchecked', checked);
	}, [checked]);

	useEffect(() => {
		console.log('This is the active', active);
	}, [active]);

	const getDocumentStatus = (document) => {};

	const getNumberOfSigReq = (status) => {
		var statusReqObjKeys = Object.keys(status);

		var countArr = [];

		statusReqObjKeys.forEach((key) => {
			var statusCount = status[key].length;

			countArr.push(statusCount);
		});

		return countArr.reduce((a, b) => a + b, 0);
	};

	return (
		<Card className={styles.pending_status_card_group} variant='outlined'>
			<CardContent>
				<div className={styles.card_title}>Out for Signature</div>

				<div className={styles.card_content}>
					{documentSignatures?.length !== 0 ? (
						<>
							{documentSignatures?.map((document, index) => {
								var status = document.documentStatuses;

								var statusKeys = Object.keys(status);
								return (
									<div className={styles.documentItem}>
										<Grid
											container
											justifyContent='space-between'
											className={styles.tab}
											data-tab={document.documentName}
											onClick={(e) => handleClickTab(e)}
										>
											<Grid
												className={styles.documentName}
											>
												{document.documentName}{' '}
												{!active[
													document.documentName
												] &&
													`(${getNumberOfSigReq(
														status
													)})`}
											</Grid>
											<Grid>
												{active[
													document.documentName
												] ? (
													<KeyboardArrowUpIcon />
												) : (
													<KeyboardArrowDownIcon />
												)}
											</Grid>
										</Grid>
										{active[document.documentName] && (
											<div
												className={
													styles.documentContent
												}
											>
												<FormGroup>
													{statusKeys.map((key) => {
														var signaturesObj =
															status[key];

														var signaturesObjKeys =
															Object.keys(
																signaturesObj
															);

														var leadIdArr = [];

														console.log(
															'signaturesObj',
															signaturesObj
														);

														signaturesObjKeys.forEach(
															(key) => {
																leadIdArr.push(
																	signaturesObj[
																		key
																	]['leadId']
																);
															}
														);

														console.log(
															'leadIdArr',
															leadIdArr
														);
														return (
															<FormControlLabel
																control={
																	<Checkbox
																		name={
																			document.documentName +
																			key
																		}
																		value={
																			leadIdArr
																		}
																		onChange={(
																			e
																		) =>
																			handleClickCheck(
																				e
																			)
																		}
																		style={{
																			color: 'var(--text-high-emphasis)',
																			marginRight:
																				'6px',
																		}}
																		defaultChecked={
																			checked ? checked[
																				document.documentName +
																					key
																			] : false
																		}
																	/>
																}
																label={
																	<typography
																		className={
																			styles.formControlLabel
																		}
																	>
																		{`${humanizer(
																			key
																		)} (${
																			leadIdArr.length
																		})`}
																	</typography>
																}
																className={
																	styles.formControl
																}
															/>
														);
													})}
												</FormGroup>
											</div>
										)}
									</div>
								);
							})}
						</>
					) : (
						<div className={styles.emptyHandler}>
							No pending status yet
						</div>
					)}
				</div>
			</CardContent>
		</Card>
	);
};

const mapStateToProps = (state) => ({
	purchaserList: state.purchasers.purchaserList,
	pendingSignatures: state.leads.pendingSignatures,
});

export default connect(mapStateToProps, { getOutForSignatureStatuses })(
	PendingStatus
);
